import { analyticsKey } from 'config/constants';

const trackUserId = (userId?: number) => {
  if (analyticsKey && window.gtag) {
    window.gtag('config', analyticsKey, {
      user_id: userId,
    });
  }
};

const trackPageView = (pathName: string) => {
  if (analyticsKey && window.gtag) {
    window.gtag('config', analyticsKey, {
      page_path: pathName,
    });
  }
};

const trackCustomEvent = <T extends keyof AnalyticsEvent>(
  event: T,
  eventParams: AnalyticsEvent[T] | {} = {},
) => {
  if (analyticsKey && window.gtag) {
    window.gtag('event', event, {
      ...eventParams,
    });
  }
};

type AnalyticsEvent = {
  // Login / Sign up
  startSignUp: {};
  completeSignUp: {};
  logIn: {};
  logOut: {};
  startForgotPassword: {};
  sendPasswordResetEmail: {};
  // Vault creation
  startVaultCreation: {
    step: 'home' | 'account';
  };
  startVaultCreationCancel: {};
  confirmVaultCreationCancel: {};
  createVaultNext: {};
  applyDiscountCode: {
    step: 'createVault' | 'account';
    discountCode: string;
  };
  startRemoveDiscountCode: {
    discountCode: string;
  };
  confirmRemoveDiscountCode: {
    discountCode: string;
  };
  startAddContributor: {
    step: 'createVault' | 'aboutVault';
  };
  confirmAddContributor: {
    step: 'createVault' | 'aboutVault';
    contributorName: string;
    contributorEmail: string;
  };
  startRemoveContributor: {
    step: 'createVault' | 'aboutVault';
  };
  confirmRemoveContributor: {
    step: 'createVault' | 'aboutVault';
    contributorName: string;
    contributorEmail: string;
  };
  createNewVault: {};
  startAddPaymentMethod: {
    step: 'createVault' | 'account';
  };
  cancelAddPaymentMethod: {};
  confirmAddPaymentMethod: {};
  confirmVaultPayment: {};
  cancelVaultPayment: {};
  // Vault details
  copyLinkToVault: {};
  openVaultMenu: {};
  startEditVault: {};
  confirmEditVault: {};
  startDeleteVault: {};
  confirmDeleteVault: {};
  startRequestVaultDownload: {};
  confirmRequestVaultDownload: {};
  selectVaultTab: {
    tab: 'clips' | 'planInterview' | 'videoCall' | 'recordUpload' | 'about';
  };
  startUpgradeVault: {};
  confirmUpgradeVault: {};
  // Clips
  startEditClip: {
    step: 'clipDetail' | 'clipMenu';
  };
  confirmEditClip: {};
  attachClipImage: {};
  makeClipPrivate: {
    step: 'clipDetail' | 'clipMenu';
  };
  makeClipPublic: {
    step: 'clipDetail' | 'clipMenu';
  };
  turnClipIntoAudioOnly: {
    step: 'clipDetail' | 'clipMenu';
  };
  turnClipIntoVideo: {
    step: 'clipDetail' | 'clipMenu';
  };
  copyClipLink: {
    step: 'clipDetail' | 'clipMenu';
  };
  startSendClipByEmail: {};
  confirmSendClipByEmail: { email: string };
  downloadClip: {
    step: 'clipDetail' | 'clipMenu';
  };
  startDeleteClip: {};
  confirmDeleteClip: {};
};

export { trackUserId, trackPageView, trackCustomEvent };
